<span>{{ 'research.search.results.assets.error' | translate }}</span>
<button mat-stroked-button>{{ 'research.aria.dialog.confirm' | translate }}</button>
